import styled, { createGlobalStyle } from 'styled-components';
import KPIContainer from '../Header/KPIContainer';
import LinksContainer from '../Header/LinksContainer';
import GanttContainer, { GanttContainerStyled, Skeleton } from './GanttContainer';
import { useCampaignContext } from 'context/CampaignContext';
import { useContext, useEffect, useState, useRef } from 'react';
import { ReactComponent as SVG_CRICLE } from '../../../assets/newAssets/circle.svg';
import KPIContainerSkeleton from '../Header/KPIContianerSkeleton';
import { FaChevronDown } from 'react-icons/fa';
import { FaSortAmountDown, FaSortAmountDownAlt } from 'react-icons/fa';
import { Selections } from 'components/Main/table/TableStyles';
import { RiCloseFill } from 'react-icons/ri';
import { useClientContext } from 'context/ClientContext';
import { IoIosSearch } from 'react-icons/io';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import OrganisationReport from './OrganisationReport';
import { useLoggingActivity } from 'customHooks/useLogging';
import reactSelect from 'react-select';
import { CustomSelect } from 'components/Header/CampaignSelectComponent';

import InputContext from 'context/InputContext';
// Global DatePicker styles
const GlobalDatePickerStyles = createGlobalStyle`
  .react-datepicker {
    background-color: ${({ theme }) => theme.placeholderBackground};
    border: 1px solid ${({ theme }) => theme.secondaryGray};
    border-radius: 7px;
    font-family: 'fontRegular';
    font-size: 11px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }


  .react-datepicker__header {
    background-color: ${({ theme }) => theme.background};
    border-bottom: 1px solid ${({ theme }) => theme.secondaryGray};
    border-radius: 7px 7px 0 0;
    padding: 8px 0;
  }

  .react-datepicker__current-month {
    color: ${({ theme }) => theme.primaryGray};
    font-family: 'fontRegular';
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 5px;
  }

  .react-datepicker__navigation {
    top: 10px;
    width: 20px;
    height: 20px;
    border: none;
    background: none;
    cursor: pointer;
    z-index: 1;
    
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 6px;
      height: 6px;
      border-style: solid;
      border-color: ${({ theme }) => theme.primaryGray};
    }

    &:hover::before {
      border-color: ${({ theme }) => theme.primaryGray}cc;
    }
  }

  .react-datepicker__navigation--previous {
    left: 8px;
    
    &::before {
      border-width: 1px 0 0 1px;
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  .react-datepicker__navigation--next {
    right: 8px;
    
    &::before {
      border-width: 1px 1px 0 0;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }

  .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .react-datepicker__day-name {
    color: ${({ theme }) => theme.primaryGray}88;
    font-size: 10px;
    width: 24px;
    line-height: 24px;
    text-align: center;
    font-family: 'fontRegular';
  }

  .react-datepicker__month {
    margin: 8px;
  }

  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__day {
    color: ${({ theme }) => theme.primaryGray};
    font-size: 11px;
    width: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'fontRegular';
    transition: all 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.primaryGray}22;
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: ${({ theme }) => theme.primaryGray};
    color: white;
    
    &:hover {
      background-color: ${({ theme }) => theme.primaryGray}dd;
    }
  }

  .react-datepicker__day--today {
    background-color: ${({ theme }) => theme.secondaryGray};
    color: ${({ theme }) => theme.primaryGray};
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.primaryGray}44;
  }
`;

const StyledCustomSelect = styled(CustomSelect)`
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  margin: 0;

  .react-select__control {
    background: ${({ theme }) => theme.placeholderBackground} !important;
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    height: 30px !important;
    min-height: 30px !important;
    font-size: 12px !important;
    /* border: 1px solid ${({ theme }) => theme.secondaryGray} !important; */
    border-radius: 7px !important;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.secondaryGray} !important;
    color: ${({ theme }) => theme.primaryGray} !important;

    &:hover {
      border: 1px solid ${({ theme }) => theme.primaryGray} !important;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }

    &.react-select__control--is-focused {
      border: 1px solid ${({ theme }) => theme.primaryGray} !important;
      box-shadow: 0 0 0 1px ${({ theme }) => theme.primaryGray} !important;
    }
  }

  .react-select__menu {
    width: 200px !important;
    background-color: ${({ theme }) => theme.placeholderBackground} !important;
    font-size: 11px !important;
    z-index: 20 !important;
  }

  .react-select__menu-list {
    max-height: 150px !important;
    padding: 4px !important;
  }

  .react-select__option {
    font-size: 11px !important;
    padding: 4px 8px !important;

    &.react-select__option--is-selected {
      color: ${({ theme }) => theme.primaryGray} !important;
    }

    &:not(.react-select__option--is-selected):not(.react-select__option--is-focused) {
      background-color: ${({ theme }) => theme.placeholderBackground} !important;
      color: ${({ theme }) => theme.primaryGray} !important;
    }
  }

  .react-select__multi-value {
    font-size: 10px !important;
    margin: 1px 2px !important;
  }

  .react-select__multi-value__label {
    font-size: 10px !important;
    padding: 1px 4px !important;
  }

  .react-select__value-container {
    padding: 0 8px !important;
    height: 30px !important;
  }

  .react-select__input {
    margin: 0 !important;
    padding: 0 !important;
  }

  .react-select__indicators {
    height: 30px !important;
  }

  .react-select__clear-indicator {
    padding: 0 4px !important;
  }

  .react-select__dropdown-indicator {
    padding: 0 4px !important;
  }
`;

const ReactSelectContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 320px;
  z-index: 10;
`;

const ClientsContainer = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 7px;
  width: fit-content;
  height: fit-content;
  border: 1px solid ${({ theme }) => theme.secondaryGray};
  position: absolute;
  top: 100%;
  left: 0;
  background-color: ${({ theme }) => theme.placeholderBackground};
  max-width: 320px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;

  .searchInput {
    padding: 6px 8px;
    margin-bottom: 4px;
    border: 1px solid ${({ theme }) => theme.secondaryGray};
    border-radius: 4px;
    font-size: 11px;
    font-family: 'fontRegular';
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.primaryGray};
    outline: none;

    &:focus {
      border-color: ${({ theme }) => theme.primaryGray};
    }

    &::placeholder {
      color: ${({ theme }) => theme.primaryGray}88;
    }
  }

  .clientList {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 140px;
    overflow-y: auto;
  }

  .icon {
    padding: 0;
    align-self: end;
  }

  input {
    display: none;
  }

  label {
    padding: 4px 8px !important;
    font-size: 11px;
    margin: 0;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'fontRegular';
    color: ${({ theme }) => theme.primaryGray};

    &:hover {
      background-color: ${({ theme }) => theme.primaryGray}22;
    }
  }

  label:has(input:checked) {
    background-color: ${({ theme }) => theme.primaryGray};
    color: white;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: fit-content;
    background-color: ${({ theme }) => theme.placeholderBackground};
    color: ${({ theme }) => theme.primaryGray};
    text-align: center;
    border: 1px solid ${({ theme }) => theme.primaryGray};
    border-radius: 4px;
    padding: 4px 8px;
    font-weight: normal;
    font-size: 10px;
    position: fixed;
    z-index: 9999;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    pointer-events: none;
  }
`;
interface DateFilterOpened {
  isDateFilterOpened: boolean;
}
const MainContainer = styled.div<DateFilterOpened>`
  position: relative;
  /* position: absolute; */
  /*   top: 100px;
  left: 0; */
  width: 100%;
  min-height: calc(100vh - 100px);
  padding-bottom: 1vh;
  margin-top: 1vh;
  padding: 0;
  //margin: 0;
  /* display: grid;
  grid-template-rows: 1fr fr; */
  /* grid-template-columns: repeat(3, 1fr); */
  /* grid-template-columns: 1fr; */
  display: flex;
  flex-direction: column;
  /* gap: 1vw; */ //USED TO BE 1VW
  //  overflow: scroll;

  .dateAccordion {
    height: fit-content;
    border-radius: 7px;
    padding: 8px;
    border: 1px solid ${({ theme }) => theme.secondaryGray};
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    background-color: ${({ theme }) => theme.placeholderBackground};
    min-width: 220px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;

    h5 {
      font-size: 12px;
      margin: 0 0 6px 0;
      color: ${({ theme }) => theme.primaryGray};
      font-family: 'fontRegular';
    }

    .datepicker {
      width: 100%;
      padding: 6px 8px;
      border: 1px solid ${({ theme }) => theme.secondaryGray};
      border-radius: 4px;
      font-size: 11px;
      font-family: 'fontRegular';
      background-color: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.primaryGray};
      margin-bottom: 8px;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primaryGray};
      }
    }

    /* DatePicker calendar styles */
    .react-datepicker {
      background-color: ${({ theme }) => theme.placeholderBackground};
      border: 1px solid ${({ theme }) => theme.secondaryGray};
      border-radius: 7px;
      font-family: 'fontRegular';
      font-size: 11px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .react-datepicker__header {
      background-color: ${({ theme }) => theme.background};
      border-bottom: 1px solid ${({ theme }) => theme.secondaryGray};
      border-radius: 7px 7px 0 0;
      padding: 8px 0;
    }

    .react-datepicker__current-month {
      color: ${({ theme }) => theme.primaryGray};
      font-family: 'fontRegular';
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 5px;
    }

    .react-datepicker__navigation {
      top: 10px;
      width: 20px;
      height: 20px;
      border: none;
      background: none;
      cursor: pointer;
      z-index: 1;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 6px;
        height: 6px;
        border-style: solid;
        border-color: ${({ theme }) => theme.primaryGray};
      }

      &:hover::before {
        border-color: ${({ theme }) => theme.primaryGray}88;
      }
    }

    .react-datepicker__navigation--previous {
      left: 8px;

      &::before {
        border-width: 1px 0 0 1px;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }

    .react-datepicker__navigation--next {
      right: 8px;

      &::before {
        border-width: 1px 1px 0 0;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    }

    .react-datepicker__day-names {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
    }

    .react-datepicker__day-name {
      color: ${({ theme }) => theme.primaryGray}88;
      font-size: 10px;
      width: 24px;
      line-height: 24px;
      text-align: center;
      font-family: 'fontRegular';
    }

    .react-datepicker__month {
      margin: 8px;
    }

    .react-datepicker__week {
      display: flex;
      justify-content: space-between;
    }

    .react-datepicker__day {
      color: ${({ theme }) => theme.primaryGray};
      font-size: 11px;
      width: 24px;
      line-height: 24px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      font-family: 'fontRegular';
      transition: all 0.2s ease;

      &:hover {
        background-color: ${({ theme }) => theme.primaryGray}22;
      }
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected {
      background-color: ${({ theme }) => theme.primaryGray};
      color: white;

      &:hover {
        background-color: ${({ theme }) => theme.primaryGray}dd;
      }
    }

    .react-datepicker__day--today {
      background-color: ${({ theme }) => theme.secondaryGray};
      color: ${({ theme }) => theme.primaryGray};
    }

    .react-datepicker__day--outside-month {
      color: ${({ theme }) => theme.primaryGray}44;
    }

    button {
      width: 100%;
      margin-bottom: 4px;
      font-size: 11px;
      padding: 6px 8px;
      border-radius: 4px;
      border: 1px solid ${({ theme }) => theme.secondaryGray};
      background-color: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.primaryGray};
      cursor: pointer;
      font-family: 'fontRegular';
      transition: all 0.2s ease;

      &:hover {
        background-color: ${({ theme }) => theme.primaryGray}22;
      }
    }
  }

  .GanttKPIs {
    width: 100%;
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
  }

  .GanttKPIs > * {
    /* flex: 1; */
    margin-right: 10px;
    width: 30vw;
  }

  .GanttContainerMain {
    width: 100%;
    position: absolute; //USED TO BE RELATIVE WITHOUT TOP
    top: 180px;
  }
  .selectedStuff {
    font-size: 10px;
    font-family: 'fontRegular';
    font-weight: normal;
    font-style: italic;
    color: ${({ theme }) => theme.primaryGray}88;
    padding: 2px 6px;
    background-color: ${({ theme }) => theme.border}44;
    border-radius: 4px;
    display: inline-block;
    white-space: nowrap;
  }

  .ribbon {
    position: absolute;
    top: 12px;
    left: 24px;
    z-index: 2;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* gap: 600px; */
    /* background-color: red; */
    width: 95%;
    padding: 5px;
    .filters {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .dateFilter,
  .sortFilter {
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.secondaryGray};
    border-radius: 7px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${({ theme }) => theme.placeholderBackground};
    height: 32px;
    min-width: fit-content;
    white-space: nowrap;
    position: relative;
    transition: all 0.2s ease;

    &:hover {
      border-color: ${({ theme }) => theme.primaryGray};
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    svg {
      height: 12px;
      width: 12px;
      display: inline-flex;
      align-self: center;
      margin-left: 8px;
      transition: transform 0.2s ease;
    }

    h6 {
      font-size: 12px;
      font-family: 'fontRegular';
      font-weight: normal;
      color: ${({ theme }) => theme.primaryGray};
      margin: 0;
      display: flex;
      align-items: center;
      line-height: 1.2;
    }

    &.opened svg {
      transform: rotate(180deg);
    }

    &.hasFilters {
      border-color: ${({ theme }) => theme.primaryGray};
      background-color: ${({ theme }) => theme.primaryGray}11;
    }

    .filterCount {
      background-color: ${({ theme }) => theme.primaryGray};
      color: white;
      font-size: 10px;
      padding: 2px 6px;
      border-radius: 10px;
      margin-left: 6px;
      margin-right: 2px;
      font-weight: 500;
      min-width: 16px;
      text-align: center;
      line-height: 1.2;
    }
  }
  .searchContainer {
    position: relative;
    display: flex;
    align-items: center;

    input {
      font-size: 12px;
      padding: 8px 12px 8px 32px;
      width: 150px;
      border: 1px solid ${({ theme }) => theme.secondaryGray};
      border-radius: 7px;
      background-color: ${({ theme }) => theme.placeholderBackground};
      color: ${({ theme }) => theme.primaryGray};
      font-family: 'fontRegular';
      transition: all 0.2s ease;

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.primaryGray};
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      &::placeholder {
        color: ${({ theme }) => theme.primaryGray}88;
      }
    }
  }

  .searchIcon {
    height: 16px;
    width: 16px;
    color: ${({ theme }) => theme.primaryGray}88;
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
  input[type='date'] {
    background-color: transparent;
  }

  .title {
    color: ${({ theme }) => theme.primaryGray};
    margin-bottom: 0.1vw;
    font-size: 0.9rem;
    font-family: 'FontRegular', sans-serif;
    font-weight: normal;
  }
  .sectionContent {
    border-radius: 7px;
    padding: 10px;
    color: ${({ theme }) => theme.primaryGray};
    height: fit-content;
    border: 1px solid ${({ theme }) => theme.border};
    margin-bottom: 1vw;
    display: flex;
  }
  h5 {
    font-family: 'FontRegular', sans-serif;
    font-weight: normal;
  }

  .dateFilter {
    height: ${({ isDateFilterOpened }) => isDateFilterOpened && 'fit-content'};
  }

  .legend {
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 7px;
    padding: 6px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    gap: 16px;
    background-color: ${({ theme }) => theme.placeholderBackground};

    .legendItem {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 6px;

      svg {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
      }

      h6 {
        font-size: 11px;
        font-family: 'fontRegular';
        font-weight: normal;
        color: ${({ theme }) => theme.primaryGray};
        margin: 0;
        white-space: nowrap;
        line-height: 1.2;
      }
    }
  }
  .viewSelector {
    height: 50px; //USED TO BE OUT AND THREE UP ROWS IN
    padding-bottom: 1.5vw;
    background-color: ${({ theme }) => theme.placeholderBackground};
    border-radius: 7px 7px 0px 0px;
    border: 1px solid ${({ theme }) => theme.border};
    z-index: 1;
    border-bottom: 0px;
    align-self: flex-end;
    button {
      margin: 0.5rem;
      padding: 0.5rem 1rem;
      cursor: pointer;
    }
  }
`;

const ToggleButtonWithText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.primaryGray};
  font-size: 0.6vw;
  padding: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  position: relative;

  .toggle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    /* border: 1px solid red; */
  }

  .toggle-switch {
    position: relative;
    display: inline-block;
    display: flex;
    width: 150px;
    height: 100%;
    padding: 0;
    /* border: 1px solid green; */
  }

  .toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    transition: all 0.3s ease;
    border-radius: 7px; /* Match parent's border-radius */
    border: none;
    color: ${({ theme }) => theme.primaryGray};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 0.6vw;
    font-family: 'fontRegular';
    overflow: hidden;
  }

  .campaigns-text,
  .reports-text {
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
    user-select: none;
    font-weight: normal;
    font-size: 12px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    height: 100%;
    font-family: 'fontRegular';
  }

  /* .campaigns-text {
    margin-left: 3px;
  }

  .reports-text {
    margin-right: 3px;
  } */

  .slider:before {
    position: absolute;
    content: '';
    height: 100%;
    width: 72px;
    left: 3px;
    top: 0px;
    background-color: ${({ theme }) => theme.secondaryGray};
    transition: all 0.3s ease;
    border-radius: 5px;
    z-index: 1;
  }

  input:checked + .slider:before {
    transform: translateX(74px);
  }

  input:hover + .slider:before {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  }

  input:checked + .slider .campaigns-text {
    color: ${({ theme }) => theme.primaryGray}88;
  }

  input:not(:checked) + .slider .reports-text {
    color: ${({ theme }) => theme.primaryGray}88;
  }

  input:checked + .slider .reports-text {
    color: white;
    font-weight: bold;
  }

  input:not(:checked) + .slider .campaigns-text {
    color: white;
    font-weight: bold;
  }

  input:focus + .slider {
    box-shadow: none;
  }
`;

// Tab toggle components removed as we're using the slide toggle

const MainStartPage = () => {
  const {
    campaignList,
    fetchedPortalData,
    setOrder,
    order,
    reducedClientList,
    filterCampaignsPerClientCode,
    endDateFilter,
    permanentCampaignList,
    startDateFilter,
    setStartDateFilter,
    setEndDateFilter,
    clientSearchTerm,
    setClientSearchTerm,
    excludeAlwaysOn,
    setExcludeAlwaysOn,
  } = useCampaignContext();
  const { activeOrganization, anyPublish, isThereAnyReadPlus } = useClientContext();
  const { organisationReportActive, setOrganisationReportViewActive } = useContext(InputContext);
  const logActivity = useLoggingActivity();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const theme = JSON.parse(window.localStorage.getItem('myTheme')!);

  const [isDateFilterOpened, setIsDateFilterOpened] = useState(false);

  // Refs for click outside detection
  const dateFilterRef = useRef<HTMLDivElement>(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dateFilterRef.current && !dateFilterRef.current.contains(event.target as Node)) {
        setIsDateFilterOpened(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // const [organisationReportActive, setOrganisationReportViewActive] = useState(false);
  // const [addCustomReportModal, setAddCustomReportModal] = useState(false);
  // const [isReportsView, setIsReportsView] = useState(false);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Add 1 to the month to get a 1-based index
  const currentDay = currentDate.getDate();
  const currentYearStartDate = new Date(currentYear, 0, 1).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const currentYearEndDate = new Date(currentYear, 11, 31).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const threeMonthsAgo = new Date(currentYear, currentMonth - 3, currentDay).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const sixMonthsAgo = new Date(currentYear, currentMonth - 6, currentDay).toISOString().substring(0, 10); // Format the date as "yyyy-mm-dd"
  const getOldestStartDate = () => {
    if (permanentCampaignList) {
      const startDateArray = permanentCampaignList?.map((el) => el?.startDate as string);

      const minStartDate =
        startDateArray &&
        (startDateArray?.reduce((a, b) => {
          return a < b ? a : b;
        }) as string);
      return minStartDate;
    }
  };
  const getendDate = () => {
    if (permanentCampaignList) {
      const endDateArray = permanentCampaignList?.map((el) => el?.endDate as string);
      const maxEndDate =
        endDateArray &&
        (endDateArray?.reduce((a, b) => {
          return a > b ? a : b;
        }) as string);
      // add 5 days to the maxEndDate
      const newDate = new Date(maxEndDate);
      newDate.setDate(newDate.getDate() + 5);
      const newDateTransformed = newDate.toISOString().substring(0, 10);
      return newDateTransformed;
    }
  };

  const arrayWithStatus = [
    {
      title: 'Not Briefed',
      color: '#BFBFBF',
    },
    {
      title: 'Briefed',
      color: '#EBC57D',
    },
    {
      title: 'Planned',
      color: '#E2FFE8',
    },
    {
      title: 'Running',
      color: '#A9C8C0',
    },
    {
      title: 'Completed',
      color: '#7D98AB',
    },
    // {
    //   title: 'Partly Published',
    //   color: '#8BAEDF',
    // },
    {
      title: 'Evaluated',
      color: '#AFA2C3',
    },
  ];

  interface IFilter {
    code: string;
    country: string;
    name: string;
  }
  const [a, setA] = useState<Array<IFilter>>([]);
  const [selectedClients, setSelectedClients] = useState<
    Array<{ label: string; value: string; code: string; country: string }>
  >([]);

  const handleClientSelectChange = (selected: any) => {
    setSelectedClients(selected || []);
    const newFilters =
      selected?.map((item: any) => ({
        code: item.code,
        country: item.country,
        name: item.label,
      })) || [];
    setA(newFilters);
  };
  useEffect(() => {
    filterCampaignsPerClientCode(a);
  }, [a, filterCampaignsPerClientCode]);

  useEffect(() => {
    // Reset local UI state when organization changes
    setSelectedClients([]);
    setA([]);
  }, [activeOrganization]);

  const handleToggleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const isReportsView = e.target.checked;

    // Log only when switching to Reports view
    if (isReportsView) {
      logActivity({
        // ← Bez await-a!
        action: 'CUSTOM_REPORT_OVERVIEW',
      }).catch(console.error); // Handle errors separately
    }

    setOrganisationReportViewActive(isReportsView);
  };

  const openedDateFilter = () => {
    return (
      <section className="dateAccordion" /* style={{ paddingTop: '7px' }} */>
        <div className="sectionContent" style={{ flexDirection: 'column' }}>
          <div style={{ flexDirection: 'column', display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h5>Start Date</h5>
              {/* <input value={startDateFilter} onChange={(e) => setStartDateFilter(e.target.value)} type="date" /> */}
              <DatePicker
                className="datepicker"
                dateFormat="dd-MM-yyyy"
                selected={startDateFilter}
                onChange={(e: any) => setStartDateFilter(e.toISOString().slice(0, 10))}
                calendarStartDay={1}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h5>End Date</h5>
              {/* <input value={endDateFilter} onChange={(e) => setEndDateFilter(e.target.value)} type="date" /> */}
              <DatePicker
                className="datepicker"
                dateFormat="dd-MM-yyyy"
                selected={endDateFilter}
                onChange={(e: any) => setEndDateFilter(e.toISOString().slice(0, 10))}
                calendarStartDay={1}
              />
            </div>
          </div>
          <div style={{ flexDirection: 'column', display: 'flex', marginTop: '5px' }}>
            <button
              type="button"
              onClick={() => {
                setStartDateFilter(currentYearStartDate);
                setEndDateFilter(currentYearEndDate);
              }}
              style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
            >
              Current year
            </button>
            <button
              type="button"
              onClick={() => {
                setStartDateFilter(getOldestStartDate() as string);
                setEndDateFilter(getendDate() as string);
              }}
              style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
            >
              Max
            </button>
            <button
              type="button"
              onClick={() => {
                setStartDateFilter(threeMonthsAgo);
                setEndDateFilter(currentDate.toISOString().substring(0, 10));
              }}
              style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
            >
              Last 3 months
            </button>
            <button
              type="button"
              onClick={() => {
                setStartDateFilter(sixMonthsAgo);
                setEndDateFilter(currentDate.toISOString().substring(0, 10));
              }}
              style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '5px' }}
            >
              Last 6 months
            </button>
          </div>
          <div></div>
        </div>
      </section>
    );
  };

  /* Toggle button implementation is now directly in the JSX */

  if (!anyPublish && !isThereAnyReadPlus) {
    return null;
  }

  return (
    <MainContainer isDateFilterOpened={isDateFilterOpened}>
      <GlobalDatePickerStyles />
      <div className="GanttKPIs">
        {fetchedPortalData ? (
          <>
            {campaignList ? <KPIContainer></KPIContainer> : <KPIContainerSkeleton></KPIContainerSkeleton>}
            <LinksContainer agency="customLinks"></LinksContainer>
            {/* <div>
              <button
                onClick={() => {
                  setOrganisationReportViewActive(!organisationReportActive);
                  setIsReportsView(!organisationReportActive);
                }}
              >
                Change view
              </button>
              <button onClick={() => setAddCustomReportModal(true)}>Add Custom report</button>
            </div> */}
          </>
        ) : (
          <></>
        )}
      </div>

      <div className="GanttContainerMain">
        {campaignList ? (
          <div>
            {organisationReportActive ? <OrganisationReport /> : <GanttContainer />}
            <div className="ribbon">
              <div className="filters">
                <div className="sortFilter" style={{ padding: 0 }}>
                  <ToggleButtonWithText>
                    <div className="toggle-container">
                      <label className="toggle-switch">
                        <input type="checkbox" checked={organisationReportActive} onChange={handleToggleChange} />
                        <span className="slider">
                          <span className="campaigns-text">Campaigns</span>
                          <span className="reports-text">Reports</span>
                        </span>
                      </label>
                    </div>
                  </ToggleButtonWithText>
                </div>
                <div className={`dateFilter ${isDateFilterOpened ? 'opened' : ''}`} ref={dateFilterRef}>
                  <h6 onClick={() => setIsDateFilterOpened(!isDateFilterOpened)}>
                    Filter by Date {isDateFilterOpened ? <RiCloseFill /> : <FaChevronDown />}
                  </h6>
                  {isDateFilterOpened && openedDateFilter()}
                </div>
                <StyledCustomSelect
                  isMulti
                  options={
                    reducedClientList?.map((client) => ({
                      label: client?.ClientName || '',
                      value: `${client?.ClientCode}-${client?.ClientCountry}`,
                      code: client?.ClientCode || '',
                      country: client?.ClientCountry || '',
                    })) || []
                  }
                  value={selectedClients}
                  onChange={handleClientSelectChange}
                  placeholder="Client Filter"
                  className="react-select-container hoho"
                  classNamePrefix="react-select"
                  isClearable
                  isSearchable
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  blurInputOnSelect={false}
                  menuShouldBlockScroll={false}
                  menuPortalTarget={null}
                  controlShouldRenderValue={false}
                  // components={{
                  //   ValueContainer: ({ children, ...props }) => (
                  //     <div
                  //       {...props}
                  //       style={{
                  //         display: 'flex',
                  //         alignItems: 'center',
                  //         padding: '0 4px',
                  //         flex: '1 1 auto',
                  //         minWidth: 0,
                  //         position: 'relative',
                  //       }}
                  //     >
                  //       <span
                  //         style={{
                  //           fontSize: '12px',
                  //           fontFamily: 'fontRegular',
                  //           display: 'flex',
                  //           alignItems: 'center',
                  //           whiteSpace: 'nowrap',
                  //           pointerEvents: 'none',
                  //           zIndex: 2,
                  //         }}
                  //       >
                  //         {/* Client Filter */}
                  //         {/* {children} */}
                  //         {selectedClients.length > 0 && (
                  //           <span
                  //             style={{
                  //               backgroundColor: '#666',
                  //               color: 'white',
                  //               fontSize: '10px',
                  //               padding: '1px 4px',
                  //               borderRadius: '10px',
                  //               marginLeft: '4px',
                  //               fontWeight: '500',
                  //               minWidth: '14px',
                  //               textAlign: 'center',
                  //               lineHeight: '1.4',
                  //               display: 'inline-flex',
                  //               alignItems: 'center',
                  //               justifyContent: 'center',
                  //               height: '14px',
                  //             }}
                  //           >
                  //             {selectedClients.length}
                  //           </span>
                  //         )}
                  //       </span>
                  //       <div
                  //         style={{
                  //           position: 'absolute',
                  //           left: 0,
                  //           top: 0,
                  //           right: 0,
                  //           bottom: 0,
                  //           zIndex: 1,
                  //           display: 'flex',
                  //           alignItems: 'center',
                  //         }}
                  //       >
                  //         {/* {children} */}
                  //       </div>
                  //     </div>
                  //   ),
                  // }}
                  formatOptionLabel={(option: any, { context }) => {
                    if (context === 'menu') {
                      return (
                        <div>
                          <div style={{ fontWeight: 'normal' }}>{option.label}</div>
                          <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic' }}>
                            {option.code} ({option.country})
                          </div>
                        </div>
                      );
                    }
                    return option.label;
                  }}
                />

                <div className="sortFilter" onClick={() => (order === 'desc' ? setOrder('asc') : setOrder('desc'))}>
                  <h6>Sort {order === 'desc' ? <FaSortAmountDown /> : <FaSortAmountDownAlt />}</h6>
                </div>
                <div className="sortFilter" onClick={() => setExcludeAlwaysOn(!excludeAlwaysOn)}>
                  <h6>{excludeAlwaysOn ? 'Include AlwaysOn' : 'Exclude AlwaysOn'}</h6>
                </div>
                <div className="searchContainer">
                  <IoIosSearch className="searchIcon" />
                  <input
                    onChange={(e) => setClientSearchTerm(e.target.value)}
                    type="search"
                    // placeholder="Search campaigns..."
                    placeholder="Search campaigns..."
                    value={clientSearchTerm}
                  />
                </div>
              </div>
              {!organisationReportActive && (
                <div className="legend">
                  {arrayWithStatus.map((item) => {
                    return (
                      <div key={item.title} className="legendItem">
                        <SVG_CRICLE fill={item.color} />
                        <h6>{item.title}</h6>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            <></>
            <GanttContainerStyled>
              <div>
                {Array(20)
                  .fill(0)
                  .map((_, index) => (
                    <Skeleton key={index} style={{ height: '35px', marginTop: index > 0 ? '10px' : '0' }} />
                  ))}
              </div>
            </GanttContainerStyled>
            {/* <div className="loaders">
                <ReactLoading type="spinningBubbles" color={theme.publishButton} />
              </div> */}
          </>
        )}
      </div>
      {/* {addCustomReportModal && <AddCustomReport setAddCustomReportModal={setAddCustomReportModal}></AddCustomReport>} */}
    </MainContainer>
  );
};

export default MainStartPage;
